import { registerBlockType } from '@wordpress/blocks'
import { __ } from '@wordpress/i18n'
import { boolean, select, text } from '@storybook/addon-knobs'
import { useState } from '@wordpress/element'
import { compose, withInstanceId } from '@wordpress/compose'
import {
	useBlockProps,
	InnerBlocks,
	RichText,
	InspectorControls,
	__experimentalBlock as Block
} from '@wordpress/block-editor'
import { withSelect } from '@wordpress/data'
import {
	Button,
	__experimentalInputControl as InputControl, FormToggle
} from '@wordpress/components'
import { PanelBody, RangeControl, SelectControl } from '@wordpress/components'
import { Component } from '@wordpress/element'
import { HEADER } from './helpers/block-templates'
import { generateUID } from './helpers/misc'

// const BaseHtml = ({setAttributes, attributes, instanceId}) => {
// }
// const CombinedComponent = compose(withInstanceId)(BaseHtml)

registerBlockType('wp-bootblock/accordion', {
	apiVersion: 2,
	title: __('Accordion – Bootblock', 'wp-bootblock'),
	description: __('A Bootstrap accordion.', 'wp-bootblock'),
	keywords: [],
	icon: 'images-alt',
	category: 'media',
	attributes: {
		id: {
			type: 'number',
			value: Math.floor(Math.random() * 10000)
		},
		isFlush: {
			type: 'boolean'
		},
		count: {
			type: 'number'
		}
	},
	edit(props) {
		const blockProps = useBlockProps({className: 'wp-bootblock'})
		const onChangeFlush = (newContent) => {
			props.setAttributes({isFlush: !props.attributes.isFlush})
		}
		return (
			<>
				<InspectorControls>
					<PanelBody title={__('Settings', 'wp-bootblock')}>
						<FormToggle
							checked={props.attributes.isFlush}
							onChange={onChangeFlush}
						/> {__('Borderless style (Flush)?', 'wp-bootblock')}
					</PanelBody>
				</InspectorControls>
				<div {...blockProps}>
					<div className={`accordion ${props.attributes.isFlush ? 'accordion-flush' : ''}`} id={`accordionId-${props.clientId}`}>
						<InnerBlocks
							template={[['wp-bootblock/accordion-collapsible', {}]]}
							allowedBlocks={['wp-bootblock/accordion-collapsible']}
						/>
					</div>
				</div>
			</>
		)
	},
	save: (props) => {
		const blockProps = useBlockProps.save({className: 'wp-bootblock'})
		return (
			<div {...blockProps}>
				<div className={`accordion ${props.attributes.isFlush ? 'accordion-flush' : ''}`} id={`accordionId-${props.clientId}`}>
					<InnerBlocks.Content/>
				</div>
			</div>
		)
	}
})
